import agentApi from '@/api/agentApi'

const SET_AGENT_LIST = 'setAgentList'
const SET_AGENT_COUNT = 'setAgentCount'

const state = {
  agentList: [],
  agentCount: 0
}

const mutations = {
  [SET_AGENT_LIST] (state, agentList) {
    state.agentList = agentList
  },
  [SET_AGENT_COUNT] (state, agentCount) {
    state.agentCount = agentCount
  }
}

const actions = {
  async getAgents ({ commit }, data) {
    try {
      const res = await agentApi.getAgents(data.page, data.pageSize, data.sort, data.filters)

      if (res && res.rcode === 0) {
        commit(SET_AGENT_LIST, res.data.agents)
        commit(SET_AGENT_COUNT, res.data.count)
      }
      return res
    } catch (err) {
      return err
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/agent.js